module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"top":"TOPP"},"en":{"top":"TOP"}}')
  delete Component.options._Ctor
}
